import {
  AccountInfoResult,
  DeployContractPackageResult,
  FTBalanceTokenResult,
  TotalRewardsResult,
  ValidatorResult,
  ValidatorsUnstakingBalanceResult,
} from '@block-explorer/entities';
import { createAction, createAsyncAction } from 'typesafe-actions';
import { DataResponse } from '../../services';

export interface AccountDetailsRequestParams {
  accountParams: { accountHash: string; includes?: string };
  accountContractPackages: { publicKey: string; includes?: string };
  biddersParams: { publicKey: string; era_id: number; includes?: string };
  unstackingParams: { publicKey: string; eraId: number };
  validatorTotalRewardParams: { publicKey: string };
  accountCep18TokensList: {
    accountHash: string;
    includes?: string;
    page?: number;
    page_size?: number;
  };
}

export const getAccountDetailsAsync = createAsyncAction(
  'GET_ACCOUNT_DETAILS_REQUEST',
  'GET_ACCOUNT_DETAILS_SUCCESS',
  'GET_ACCOUNT_DETAILS_FAILURE'
)<
  AccountDetailsRequestParams,
  [
    DataResponse<ValidatorsUnstakingBalanceResult>,
    DataResponse<ValidatorResult>,
    DataResponse<AccountInfoResult>,
    DataResponse<TotalRewardsResult>,
    DataResponse<FTBalanceTokenResult[]>,
    DataResponse<DeployContractPackageResult[]>,
  ],
  any
>();

export const updateActiveAccountHashes = createAction(
  'UPDATE_ACTIVE_ACCOUNT_HASHES'
)<{ publicKey: string; accountHash: string }>();

export const addTokensBalanceToTotalBalance = createAction(
  'ADD_TOKENS_BALANCE_TO_TOTAL_BALANCE'
)<{
  totalTokensBalanceInCurrency: string;
}>();

export const resetAccountDetails = createAction('RESET_ACCOUNT_INFO')();
